import React, { useState } from "react"
import Navbar from "../components/Navbar"
import News from "../components/News"
import Footer from "../components/Footer"
import {
  Container,
  Wrapper,
  Title,
  Form,
  Input,
  Button,
} from "../styles/RegisterStyle"
import { useDispatch } from "react-redux"
import { renderErrorMsg } from "../services/errorsForm"
import { register } from "../redux/apiCall"
import { Snackbar, IconButton } from "@mui/material"
import { Close } from "@material-ui/icons"

export default function Register() {
  const [registerForm, setRegisterForm] = useState()
  const dispatch = useDispatch()
  const [formErrorMsg, setFormErrorMsg] = useState()

  const handleChangeForm = (e) => {
    setRegisterForm({
      ...registerForm,
      [e.target.name]: e.target.value,
    })
  }
  const onRegister = (e) => {
    e.preventDefault()
    register(dispatch, registerForm, setFormErrorMsg, handleClick)
  }
  // snackbar when user registered
  const [open, setOpen] = useState(false)
  const handleClick = () => {
    setOpen(true)
  }
  const handleClose = (reason) => {
    if (reason === "clickaway") {
      return
    }
    setOpen(false)
  }
  const closeSnackbarButton = (
    <IconButton
      size='small'
      aria-label='close'
      color='inherit'
      onClick={handleClose}>
      <Close fontSize='small' color='white' />
    </IconButton>
  )

  return (
    <Container>
      <News />
      <Navbar />
      <Wrapper>
        <Title>Create an account</Title>
        <Form id='registerForm'>
          <Input
            placeholder='First Name'
            onChange={handleChangeForm}
            name='first_name'></Input>
          {renderErrorMsg(formErrorMsg, "first_name")}
          <Input
            placeholder='Last Name'
            onChange={handleChangeForm}
            name='last_name'></Input>{" "}
          {renderErrorMsg(formErrorMsg, "last_name")}
          <Input
            placeholder='email'
            onChange={handleChangeForm}
            name='email'></Input>{" "}
          {renderErrorMsg(formErrorMsg, "email")}
          <Input
            placeholder='Phone Number'
            onChange={handleChangeForm}
            name='phone'></Input>{" "}
          {renderErrorMsg(formErrorMsg, "phone")}
          <Input
            placeholder='Address'
            onChange={handleChangeForm}
            name='address'></Input>{" "}
          {renderErrorMsg(formErrorMsg, "address")}
          <Input
            placeholder='Password'
            onChange={handleChangeForm}
            name='password'
            type='password'></Input>{" "}
          {renderErrorMsg(formErrorMsg, "password")}
          <Input
            placeholder='Password Confirm'
            onChange={handleChangeForm}
            name='password_confirm'
            type='password'></Input>{" "}
          {renderErrorMsg(formErrorMsg, "password_confirm")}
          <Button onClick={onRegister}>Create account</Button>
        </Form>
      </Wrapper>
      <Footer />
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message='Registered Successfully'
        action={closeSnackbarButton}
      />
    </Container>
  )
}
